import { Radio } from "lucide-react";
import { toast } from "sonner";
import { activeRun, startLive, stopRun, useLocalRuns } from "@/runs/local-runs";
import { activeWorkspace } from "@/workspace/file-ops";
import { useWs } from "@/workspace/context";
import type { PluginCommand } from "./registry";

/**
 * Live Server (plugin `kompil.live-server`, app desktop): o site do projeto em localhost
 * (5500, 5501… um por projeto), recarregando a cada alteração — sua ou de quem programa junto.
 * A raiz é a pasta do index.html (raiz do projeto ou public/). Continua no ar fora do projeto:
 * a lista fica no ícone de execuções da barra de título.
 */
export { siteRoot } from "@/runs/local-runs";

function current() {
  const ws = activeWorkspace.current;
  if (!ws) return null;
  return { id: ws.detail.project.id, name: ws.detail.project.name };
}

export async function startLiveServer() {
  const project = current();
  if (!project) return void toast("Abra um projeto para pré-visualizar o site.");
  await startLive(project);
}

export async function stopLiveServer() {
  const project = current();
  const run = project ? activeRun(useLocalRuns.getState().runs, project.id, "live") : null;
  if (run) await stopRun(run.id);
}

export const LIVE_SERVER_COMMANDS: PluginCommand[] = [
  {
    id: "live-server.start",
    title: "Pré-visualizar: abrir o site no navegador",
    run: () => void startLiveServer(),
  },
  {
    id: "live-server.stop",
    title: "Pré-visualizar: parar o servidor local",
    run: () => void stopLiveServer(),
  },
];

/** Barra de status: "Pré-visualizar" (como no VS Code) ou a porta em uso deste projeto. */
export function LiveServerStatusItem() {
  const { detail } = useWs();
  const run = useLocalRuns((s) => activeRun(s.runs, detail.project.id, "live"));
  const starting = run?.status === "starting";
  const port = run?.ports[0] ?? null;
  return (
    <button
      onClick={() => void (run ? stopLiveServer() : startLiveServer())}
      className="flex items-center gap-1.5 hover:text-fg"
      title={run?.url ? `${run.url} — clique para parar` : "Abrir o site do projeto em localhost"}
    >
      <Radio className={run ? "h-3 w-3 animate-pulse-dot" : "h-3 w-3"} />
      {starting ? "iniciando…" : port ? `porta ${port}` : "Pré-visualizar"}
    </button>
  );
}
